import { MoreVerticalIcon, TrashIcon } from "vega-icons";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@vega-core/components/shadcn/dropdown-menu";
import { m } from "@vega-core/paraglide/messages";

type NodeActionsMenuProps = {
  nodeId: string;
  nodeName: string;
  onAddDocument?: () => void;
  onCreateFolder?: () => void;
  onDelete: () => void;
};

export function NodeActionsMenu({
  nodeId,
  nodeName,
  onAddDocument,
  onCreateFolder,
  onDelete,
}: NodeActionsMenuProps) {
  const hasAddActions = Boolean(onAddDocument || onCreateFolder);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label={m.coInvestments_dataRoom_nodeActionsMenu({
            name: nodeName,
          })}
          className="flex size-5 shrink-0 items-center justify-center rounded text-icon/secondary hover:bg-background/brand/opacity hover:text-brand-default focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-default"
          data-testid={`node-actions-menu-${nodeId}`}
          type="button"
        >
          <MoreVerticalIcon className="size-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={4}>
        {onAddDocument ? (
          <DropdownMenuItem onSelect={onAddDocument}>
            {m.coInvestments_dataRoom_addDocument()}
          </DropdownMenuItem>
        ) : null}
        {onCreateFolder ? (
          <DropdownMenuItem onSelect={onCreateFolder}>
            {m.coInvestments_dataRoom_createFolder()}
          </DropdownMenuItem>
        ) : null}
        {hasAddActions ? <DropdownMenuSeparator /> : null}
        <DropdownMenuItem className="text-text/negative" onSelect={onDelete}>
          <TrashIcon className="size-3.5" />
          {m.coInvestments_dataRoom_delete()}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
